import React from "react";
import "./styling.scss";
import Message from "../common/message";
import { Circles, JumpingBeans } from "../common/loadingComponent";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


class StylingComponent extends React.Component {
    render() {
        console.log("started");
        return (
            <div className="content-root">
            
                <h1>CERVENA TEMA</h1>
                {this.renderColorBox("#ae7199", "")}
                {this.renderColorBox("#e74360", "")}
                {this.renderColorBox("#f08635", "")}
                {this.renderColorBox("#f5b31c", "")}
                {this.renderColorBox("#fae300", "")}

                <h1>MODRA TEMA</h1>
                {this.renderColorBox("#002455", "")}
                {this.renderColorBox("#01488a", "")}
                {this.renderColorBox("#0b809e", "")}
                {this.renderColorBox("#14b8b1", "")}
                <JumpingBeans/>
                <h1>FARBY</h1>
                {this.renderColorBox("#9fd300", "green - Itrade progress, relations (pozitivne hodnotenie)")}
                {this.renderColorBox("#ffd200", "yellow - Itrade progress, relations (neutralne hodnotenie, VI)")}
                {this.renderColorBox("#f34454", "red - Itrade progress, relations (zaporne hodnotenie, VI)")}
                {this.renderColorBox("#444749", "font vsade")}
                {this.renderColorBox("#aaaaaa", "history button")}
                {this.renderColorBox("#fae300", "gradient 1 ")}
                {this.renderColorBox("#f08635", "gradient 2 ")}
                {this.renderColorBox("#e74360", "gradient 3 ")}
                {this.renderColorBox("#ae7199 ", "gradient 4 ")}
                {this.renderColorBox("#61b4e4", "gradient 5 ")}
                {this.renderColorBox("#d5d7d9", "siva 2 ")}
                {this.renderColorBox("#F0F0F0", "siva 3 ")}
                {this.renderColorBox("#dedede", "okraje vo formulari")}
                {this.renderColorBox("#fbfbfb", "background aplikacie ")}
                {this.renderColorBox("#f58228", "link")}
                {this.renderColorBox("#04C699", "zelena 2")}
                <br />
                <Message type="error" message="Cupcake ipsum dolor. Sit amet carrot cake sugar plum I love oat cake croissant. Dragée tiramisu halvah carrot cake danish croissant wafer gingerbread. Candy gummi bears donut cheesecake." />
                <Message type="warning" message="Cupcake ipsum dolor. Sit amet carrot cake sugar plum I love oat cake croissant. Dragée tiramisu halvah carrot cake danish croissant wafer gingerbread. Candy gummi bears donut cheesecake." />
                <Message type="success" message="Cupcake ipsum dolor. Sit amet carrot cake sugar plum I love oat cake croissant. Dragée tiramisu halvah carrot cake danish croissant wafer gingerbread. Candy gummi bears donut cheesecake." />
                <Message type="info" message="Cupcake ipsum dolor. Sit amet carrot cake sugar plum I love oat cake croissant. Dragée tiramisu halvah carrot cake danish croissant wafer gingerbread. Candy gummi bears donut cheesecake." />
                <Message type="processing" message="Cupcake ipsum dolor. Sit amet carrot cake sugar plum I love oat cake croissant. Dragée tiramisu halvah carrot cake danish croissant wafer gingerbread. Candy gummi bears donut cheesecake." />
                <Circles />
                <Circles useLoginColor />



            </div >
        )
    }

    onChange() {
        this.setState({ checked: !this.state.checked });
    }
    renderColorBox = (color, text) => {
        return (
            <div>
                <div style={{ background: color, minWidth: "100px", height: "30px", color: color === "#444749" ? "#fff" : "#444749" }}>{color} - {text}</div>
            </div>
        )
    }
}


export default StylingComponent;